import sithMesIIStoresPlan from "@/store/sithMesII/plan/moduleIndex-store-sithMesII-plan";
import sithMesIIStoresPds from "@/store/sithMesII/pds/moduleIndex-store-sithMesII-pds";

const entities = {
    ...sithMesIIStoresPlan,
    ...sithMesIIStoresPds,
}

export default entities
